import { render, staticRenderFns } from "./SeletorDePdv.vue?vue&type=template&id=612e06a4&scoped=true&"
import script from "./SeletorDePdv.vue?vue&type=script&lang=ts&"
export * from "./SeletorDePdv.vue?vue&type=script&lang=ts&"
import style0 from "./SeletorDePdv.vue?vue&type=style&index=0&id=612e06a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e06a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VCol,VContainer,VIcon})
